import GlobalLayout from './GlobalLayout/GlobalLayout'
import PageLayout from './PageLayout/PageLayout'

export {
  GlobalLayout,
  PageLayout,
}
